import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { LogOut } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { useClienteAuthStore } from '@/stores/clienteAuthStore';
import { clienteMobileService } from '@/services/clienteMobileService';

export function ClientePerfilPage() {
  const navigate = useNavigate();
  const user = useClienteAuthStore((s) => s.user);
  const logout = useClienteAuthStore((s) => s.logout);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Sessão encerrada');
    navigate('/cliente/login', { replace: true });
  };

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('Nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    setSaving(true);
    try {
      await clienteMobileService.changePassword(currentPassword, newPassword);
      toast.success('Senha alterada com sucesso.');
      setCurrentPassword('');
      setNewPassword('');
    } catch {
      toast.error('Não foi possível alterar a senha. Verifique a senha atual.');
    } finally {
      setSaving(false);
    }
  };

  const cf = user?.clienteFornecedor;

  return (
    <div className="space-y-6 max-w-lg">
      <Card>
        <CardHeader>
          <CardTitle>Seus dados</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <div>
            <p className="text-muted-foreground">Nome</p>
            <p className="font-medium">{cf?.nome ?? '—'}</p>
          </div>
          <div>
            <p className="text-muted-foreground">E-mail</p>
            <p className="font-medium">{user?.email ?? '—'}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Empresa</p>
            <p className="font-medium">{cf?.company?.name ?? '—'}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Código cliente</p>
            <p className="font-medium">{cf?.codigo ?? '—'}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Placa</p>
            <p className="font-medium">{cf?.placa ?? '—'}</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Alterar senha</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleChangePassword} className="space-y-4">
            <Input
              label="Senha atual"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
            />
            <Input
              label="Nova senha"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
            />
            <Button type="submit" loading={saving} disabled={!currentPassword || !newPassword}>
              Salvar nova senha
            </Button>
          </form>
        </CardContent>
      </Card>

      <Button type="button" variant="destructive" className="w-full gap-2" onClick={handleLogout}>
        <LogOut className="h-4 w-4" />
        Sair
      </Button>
    </div>
  );
}
